import { makeAutoObservable } from "mobx";
export class InteractionStore {
  private static instance: InteractionStore;

  public loading = false;
  public redirectTo: string | null = null;
  public xdomain: string | null = null;
  public navigate: string | null = null;

  private constructor() {
    makeAutoObservable(this);
  }

  public static getInstance(): InteractionStore {
    if (!InteractionStore.instance) {
      InteractionStore.instance = new InteractionStore(); // Create instance if it doesn't exist
    }
    return InteractionStore.instance; // Return the existing instance
  }

}
